import React, { useContext, useState } from 'react'
import './PageSection.css';
import EventContext from '../contexts/EventContext';
import { useEffect } from 'react';

const PageSection = (props) => {

    const eventContext = useContext(EventContext);

    const [customisedTitleStyle, setCustomisedTitleStyle] = useState('animatedgradient');

    const { currentEvent, mainPlanAction } = eventContext;

    const style = { ...props.style, borderBottom: "" }


    useEffect(() => {

        if (currentEvent && currentEvent.id_event === "2139") {
            setCustomisedTitleStyle("text-blue-500 dark:text-blue-200");
        }

        if (mainPlanAction) {
            setCustomisedTitleStyle("");
        }


    }, [currentEvent, mainPlanAction]);

    return <section className={`${props.className} page-section py-5 dark:bg-neutral-950`} style={style} >
        {props.title && <h1
            style={{ color: mainPlanAction && mainPlanAction.cycle_lang_color_1 ? mainPlanAction.cycle_lang_color_1 : '#5e062c' }}
            className={` ${customisedTitleStyle} text-3xl lg:text-6xl mb-2 text-center  ${props.darkmode ? `dark:text-white` : ''}`}
        >{props.title}</h1>}
        {props.children}

    </section>
}

export default PageSection;